<template>
  <div>
    <PageMenu :linksList="linksList" />
    <div class="add-button c-float m-b-10 flex is-flex-wrap">
      <div class="flex" style="flex-grow: 1; align-items: center; display: flex; gap: 16px;">
        <p class="user-name">{{ pageTitle }}</p>
      </div>
      <div class="flex">
        <Dropdown
          class="flex drop-right m-r-10"
          :buttonText="$t('add')"
          :dropdownOptions="currentDropdownOptions"
          @optionSelected="optionSelected"
        />
      </div>
    </div>

    <DataTable
      :key="activeTab"
      :customTable=false
      :type="currentType"
      :dropdown=false
      :tableHeader=true
      :tableHead=true
      tableActions="ITEMS"
      tableAPI="ITEMS"
      :actionsOptions="actionsOptions"
      :totalCount="totalCount"
      :checkbox=true
      :count="currentCount"
      :list="currentList"
      :rowActionParameter="rowActionParameter"
      :referenceData="currentReferenceData"
      :filterOptions="currentFilterOptions"
      :updateIterator="updateIterator"
      @updatedSelections="tableSelectionsUpdated"
      @actionOptionTriggered="actionOptionTriggered"
      @rowAction="rowAction" />
    <Popup
      v-if="openImport"
      :showConfirmButton="showImportButton && !get_error_message"
      :confirmText="$t('import')"
      @cancel="togglePopupEdit"
      @confirm="submitForm">
      <template v-slot:header>
        <h2>{{ $t('Import Template') }}</h2>
      </template>
      <UploadTemplate
        @enabeImport="enableImport"
        @disableImport="showImportButton = false"
        @closePopup="closePopupAndTrackImportProcess"
        @uploaded="updateTableAfterUpload"
        templateType="item_fields"
        :typeId="activeTab === 'descriptions' ? 2 : 1" />
      <message v-if="get_error_message.type" name="warning" :data="get_error_message"></message>
    </Popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import mixin from '@/mixins/mixins.js';
import Popup from '@/components/global/popup';
import DataTable from '@/components/table/index.vue';
import UploadTemplate from '@/components/global/uploadTemplate';
import AddressPicker from '@/components/global/addressPicker/index.vue';
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import PhoneSelect from '@/components/elements/inputs/phone.vue';
import Dropdown from '@/components/global/dropdown';
import PageMenu from '@/components/global/pageMenu';
import formValidator from '@/mixins/formValidator';
import EventBus from '@/eventBus';

/* eslint-disable */
export default {
  name: 'Items',
  components: {
    DataTable,
    Popup,
    UploadTemplate,
    AddressPicker,
    InputText,
    PhoneSelect,
    InputSelect,
    Dropdown,
    PageMenu,
  },
  mixins: [mixin,formValidator],
  data() {
    return {
      activeTab: 'products',
      updateIterator: 1,
      openImport: false,
      totalCount: 300,
      showImportButton: false,
      rowActionParameter: {
        param: 'id',
        text: `${this.$t('view_item')}`,
      },
      type: {
        type: false,
        image: true,
        data: 'image'
      },
      referenceData: [
        {
          name: `${this.$t('name')}`,
          sku_code: `${this.$t('sku_code')}`
        },
      ],
      referenceDataDescriptions: [
        {
          description: `${this.$t('description')}`,
        },
      ],
      actionsOptions: [
        {
          text: `${this.$t('delete')}`,
          subText: `${this.$t('Delete selections')}`,
          icon: 'deleteForever',
        },
      ],
    }
  },
  created() {
    this.setActiveTabFromRoute(this.$route);
  },
  computed: {
    linksList() {
      return [
        { name: this.$t('LBL_PRODUCTS'), link: '/items/products', visible: true },
        { name: this.$t('LBL_DESCRIPTIONS'), link: '/items/descriptions', visible: true },
      ];
    },
    pageTitle() {
      return this.activeTab === 'descriptions' ? this.$t('LBL_DESCRIPTIONS') : this.$t('LBL_PRODUCTS');
    },
    currentDropdownOptions() {
      if (this.activeTab === 'descriptions') {
        return [
          {
            text: `${this.$t('LBL_ADD_DESCRIPTION')}`,
            subText: `${this.$t('TXT_CREATES_NEW_DESCRIPTION')}`,
            icon: 'plus',
            action: 'add-description',
          },
        ];
      }
      return [
        {
          text: `${this.$t('LBL_ADD_PRODUCT')}`,
          subText: `${this.$t('TXT_CREATES_NEW_PRODUCT')}`,
          icon: 'plus',
          action: 'add-product',
        },
        {
          text: `${this.$t('LBL_IMPORT_PRODUCTS')}`,
          subText: `${this.$t('TXT_UPLOAD_PRODUCTS_FROM_TEMPLATE')}`,
          icon: 'cloudUpload',
          action: 'upload-products',
        },
      ];
    },
    ...mapGetters([
      'get_items_list',
      'get_items_count',
      'get_filters_menu',
      'get_active_filter',
      'get_error_message',
      'get_import_queue',
    ]),
    // Current table bindings based on active tab
    currentType() {
      if (this.activeTab === 'descriptions') {
        return { type: false, image: false, data: '' };
      }
      return this.type;
    },
    currentReferenceData() {
      return this.activeTab === 'descriptions' ? this.referenceDataDescriptions : this.referenceData;
    },
    currentFilterOptions() {
      if (this.activeTab !== 'descriptions') return this.filterOptions;
      // Descriptions view: filter by type_id=2 + simple fields
      return {
        filtersMenu: this.get_filters_menu,
        activeFilter: this.get_active_filter,
        tableName: 'items',
        tableApi: 'items/get-list',
        filterFields: {
          type_id: {
            label: 'type_id',
            type: 'hidden',
            value: { value: '2', additional: '' },
          },
          description: {
            label: `${this.$t('description')}`,
            type: 'input',
            value: { value: '', additional: '' },
          },
          is_visible: {
            label: `${this.$t('is_visible')}`,
            type: 'select',
            value: { value: '', additional: '' },
            options: [
              { text: `${this.$t('yes')}`, value: '1' },
              { text: `${this.$t('no')}`, value: '0' },
            ],
          },
        },
        actionsOptions: this.actionsOptions,
      };
    },
    currentCount() {
      return this.get_items_count;
    },
    currentList() {
      // Backend filters by type_id via hidden filter; no FE heuristic filtering needed
      return this.get_items_list;
    },
    // Original full filter set for Products
    filterOptions() {
      return {
        filtersMenu: this.get_filters_menu,
        activeFilter: this.get_active_filter,
        tableName: 'items',
        tableApi: 'items/get-list',
        filterFields: {
          type_id: {
            label: 'type_id',
            type: 'hidden',
            value: { value: '1', additional: '' },
          },
          name: {
            label: `${this.$t('name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sku_code: {
            label: `${this.$t('sku_code')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          ean_number: {
            label: `${this.$t('ean_number')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          is_visible: {
            label: `${this.$t('is_visible')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('yes')}`, value: '1'},
              {text: `${this.$t('no')}`, value: '0'},
            ],
          },
          contains_dangerous_goods: {
            label: `${this.$t('dangerous_goods')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('yes')}`, value: '1'},
              {text: `${this.$t('no')}`, value: '0'},
            ],
          },
          contains_temp_controlled: {
            label: `${this.$t('temp_controlled')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('yes')}`, value: '1'},
              {text: `${this.$t('no')}`, value: '0'},
            ],
          },
        },
        actionsOptions: [
          {
            text: `${this.$t('delete')}`,
            subText: `${this.$t('Delete selections')}`,
            icon: 'deleteForever',
          },
        ],
      }
    },
  },
  methods: {
    setActiveTabFromRoute(route) {
      const pathParts = route.path.split('/').filter(Boolean);
      const tabFromPath = pathParts[pathParts.length - 1];

      if (tabFromPath === 'descriptions' || tabFromPath === 'products') {
        this.activeTab = tabFromPath;
      } else {
        // Default to products and redirect
        this.activeTab = 'products';
        if (route.path === '/items' || route.path === '/items/') {
          this.$router.replace('/items/products');
        }
      }
    },
    rowAction(val) {
      if (this.activeTab === 'descriptions') {
        this.$router.push(`/items/${val}/edit-item?type=description`);
      } else {
        this.$router.push(`/items/${val}/edit-item`);
      }
    },
    optionSelected(dropKey, option) {
      // Prefer explicit action flag when provided
      const action = option && option.action ? option.action : null;
      const goToAddProduct = () => this.$router.push('/items/add-item');
      const goToAddDescription = () => this.$router.push('/items/add-item?type=description');
      const openUpload = () => this.openImportTemplatePopup();

      if (action) {
        if (action === 'add-product') return goToAddProduct();
        if (action === 'add-description') return goToAddDescription();
        if (action === 'upload-products') return openUpload();
      }

      // Fallback by item order if no explicit action provided
      if (this.activeTab === 'descriptions') {
        // Only one option: Add Description
        return goToAddDescription();
      }
      // Products tab
      if (dropKey === 'dropOption1') return goToAddProduct();
      if (dropKey === 'dropOption2') return openUpload();
    },
    // Table actions
    updateTableAfterUpload() {
      this.updateIterator++;
    },
    tableSelectionsUpdated(val) {
      this.selectedItems = val.selectedList;
      this.isTableAllSelected = val.selectTotalRows;
    },
    actionOptionTriggered(option) {
      if (option.dropOption == 'dropOption1') {
        // Delete
        if (this.isTableAllSelected) {
          this.$store.dispatch('DELETE_ITEMS', {
            type: 'byFilter',
            search: this.$route.query.search,
            searchTerm: this.$route.query.searchTerm,
            count: this.get_items_count,
          }).then(() => {
            console.log('DELETE ITEMS byFilter')
            this.updateIterator++
          });
        } else {
          this.$store.dispatch('DELETE_ITEMS', {
            type: 'byId',
            id: 0,
            ids: option.list,
          }).then(() => {
            console.log('DELETE ITEMS byID')
            this.updateIterator++
          });
        }
      }
    },
    openImportTemplatePopup() {
      this.openImport = true;
      this.$store.dispatch('GET_TEMPLATES');
    },
    closePopupAndTrackImportProcess() {
      this.togglePopupEdit();
    },
    togglePopupEdit() {
      this.openImport = !this.openImport;
    },
    enableImport() {
      this.showImportButton = true;
    },
    submitForm() {
      EventBus.$emit('import_template');
    },
  },
  watch: {
    $route(to) {
      this.setActiveTabFromRoute(to);
    },
    get_import_queue: {
      handler(newValue) {
        newValue.forEach(queObj => {
          if(queObj.templateType == 'item_fields' && queObj.progressStatus == 100) {
            this.updateIterator++;
          }
        })
      },
      deep: true
    }
  },
  mounted() {

  }
};
</script>
